export default () => {}

export function getImage(src: any) {
  return {
    url: src,
  }
}
